<template>
  <div id="companyBox" style="width: 100%;">
    <Breadcrumbs :title="$t('lbl_EMPBE_CompanyInfoCenter')" v-if="!this.supplierId" />
    <visitorPermission>
      <template v-slot:body>
        <div class="container-fluid">
          <div class="tbbody">
            <b-form
              :class="[fromAdmin ? 'formAdmin' : 'form', { formAdminApproval: fromAdmin && isApprovalMode, 'Newproductbox--has-draft-banner': showDraftBanner && !fromAdmin }]"
              :style="formDynamicStyle"
              class="theme-form datepicker-responsive"
              id="companyInfoForm"
            >
              <!-- 管理员页头（与 productDetail 一致） -->
              <div class="TabHeader_admin customStickyCardHeader" v-if="fromAdmin" ref="stickyHeader">
                <div v-if="showDraftBanner" class="product-draft-banner product-draft-banner--above-body">
                  <svg class="product-draft-banner__icon" width="19" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 11H12V9H4V11ZM4 14H12V12H4V14ZM4 17H9V15H4V17ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z" fill="#5D5125"/>
                  </svg>
                  <div class="product-draft-banner__content">
                    <div class="product-draft-banner__title">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Title') }}</div>
                    <div class="product-draft-banner__desc">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Desc') }}</div>
                  </div>
                </div>
                <div class="TabHeader_body">
                  <div class="headerTitleBlock">
                    <div class="statusLine">
                      <span class="statusLabel">{{ $t('lbl_EMPBE_ProductsStatus') }}</span>
                      <span
                        v-show="statusLoaded"
                        class="statusPill"
                        :class="launchStatusClass"
                        v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Company_LaunchStatus_Tooltip'))"
                      ><i class="product-launch-badge__dot"></i>{{ launchStatusLabel }}</span>
                      <span class="statusLabel">{{ $t('lbl_EMPBE_ReviewStatus') }}</span>
                      <span
                        v-show="statusLoaded"
                        class="statusPill"
                        :class="reviewStatusClass"
                        v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Company_ReviewStatus_Tooltip'))"
                      >{{ reviewStatusLabel }}</span>
                    </div>
                  </div>
                  <div class="topMenuRight">
                    <div class="topActionGroup">
                      <span
                        class="headerActionBtn-wrap"
                        v-b-tooltip.hover.bottom="viewLiveTooltipConfig()"
                      >
                        <button
                          type="button"
                          class="headerActionBtn"
                          :disabled="!canViewLive"
                          @click="todoViewLive"
                        >
                          <span class="headerActionBtn__label">{{ $t('lbl_EMPBE_ViewPublishedVersion') }}</span>
                          <img class="headerActionBtn__icon" :src="iconOpenInNew" alt="" />
                        </button>
                      </span>
                      <PubCustomSelect flat :LiList="GetLiList" :disabled="isMoreActionDisabled" @ResultClick="handleMoreAction">
                        <template v-slot:HeadTitle>
                          <div class="headerMoreAction">{{ $t('lbl_EMPBE_MoreAction') }}</div>
                        </template>
                      </PubCustomSelect>
                    </div>
                  </div>
                </div>
              </div>

              <!--end-->
              <div class="TabHeader" v-else ref="stickyHeader">
                <div v-if="showDraftBanner" class="product-draft-banner product-draft-banner--above-body">
                  <svg class="product-draft-banner__icon" width="19" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 11H12V9H4V11ZM4 14H12V12H4V14ZM4 17H9V15H4V17ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z" fill="#5D5125"/>
                  </svg>
                  <div class="product-draft-banner__content">
                    <div class="product-draft-banner__title">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Title') }}</div>
                    <div class="product-draft-banner__desc">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Desc') }}</div>
                  </div>
                </div>
                <div class="TabHeader_body">
                  <div class="headerTitleBlock">
                    <div class="statusLine">
                      <span class="statusLabel">{{ $t('lbl_EMPBE_ProductsStatus') }}</span>
                      <span
                        v-show="statusLoaded"
                        class="statusPill"
                        :class="launchStatusClass"
                        v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Company_LaunchStatus_Tooltip'))"
                      ><i class="product-launch-badge__dot"></i>{{ launchStatusLabel }}</span>
                      <span class="statusLabel">{{ $t('lbl_EMPBE_ReviewStatus') }}</span>
                      <span
                        v-show="statusLoaded"
                        class="statusPill"
                        :class="reviewStatusClass"
                        v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Company_ReviewStatus_Tooltip'))"
                      >{{ reviewStatusLabel }}</span>
                    </div>
                  </div>
                  <div class="topMenuRight">
                    <div class="topActionGroup">
                      <span
                        class="headerActionBtn-wrap"
                        v-b-tooltip.hover.bottom="viewLiveTooltipConfig()"
                      >
                        <button
                          type="button"
                          class="headerActionBtn"
                          :disabled="!canViewLive"
                          @click="todoViewLive"
                        >
                          <span class="headerActionBtn__label">{{ $t('lbl_EMPBE_ViewPublishedVersion') }}</span>
                          <img class="headerActionBtn__icon" :src="iconOpenInNew" alt="" />
                        </button>
                      </span>
                      <PubCustomSelect
                        v-if="showSupplierMoreAction"
                        flat
                        :LiList="GetLiList"
                        :disabled="isMoreActionDisabled"
                        @ResultClick="handleMoreAction"
                      >
                        <template v-slot:HeadTitle>
                          <div class="headerMoreAction">{{ $t('lbl_EMPBE_MoreAction') }}</div>
                        </template>
                      </PubCustomSelect>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showEditSupplierRejectBanner"
                  class="product-reject-banner"
                >
                  <div class="product-reject-banner__title">{{ $t('lbl_EMPBE_CompanyInfo_RejectBanner_Title') }}</div>
                  <!-- 第二行固定默认说明；有总驳回原因时再追加一行 -->
                  <div class="product-reject-banner__desc-group">
                    <p class="product-reject-banner__desc">{{ $t('lbl_EMPBE_ProductInfo_RejectBanner_Desc') }}</p>
                    <p
                      v-if="rejectBannerHeaderReason"
                      class="product-reject-banner__desc"
                    >{{ rejectBannerHeaderReason }}</p>
                  </div>
                  <button
                    v-if="rejectedApprovalCount > 0"
                    type="button"
                    class="product-reject-banner__link"
                    @click="showRejectDetailsModal = true"
                  >
                    {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_ViewDetails', { totalNo: rejectedApprovalCount }) }}
                    <i class="fa fa-angle-right product-reject-banner__link-icon" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              <!-- 管理员编辑模式已驳回横幅：不吸顶 -->
              <div
                v-if="fromAdmin && showEditSupplierRejectBanner"
                class="product-reject-banner"
              >
                <div class="product-reject-banner__title">{{ $t('lbl_EMPBE_CompanyInfo_RejectBanner_Title') }}</div>
                <div class="product-reject-banner__desc-group">
                  <p class="product-reject-banner__desc">{{ $t('lbl_EMPBE_ProductInfo_RejectBanner_Desc') }}</p>
                  <p
                    v-if="rejectBannerHeaderReason"
                    class="product-reject-banner__desc"
                  >{{ rejectBannerHeaderReason }}</p>
                </div>
                <button
                  v-if="rejectedApprovalCount > 0"
                  type="button"
                  class="product-reject-banner__link"
                  @click="showRejectDetailsModal = true"
                >
                  {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_ViewDetails', { totalNo: rejectedApprovalCount }) }}
                  <i class="fa fa-angle-right product-reject-banner__link-icon" aria-hidden="true"></i>
                </button>
              </div>

              <!-- 总驳回：不放进吸顶标题栏，滚动时随页面往上掩起（与产品审批一致） -->
              <CompanyOverallRejectPanel
                ref="overallRejectPanel"
                v-if="statusLoaded && isApprovalMode && showProductRejectPanels"
                v-model="overallRejectReasonDraft"
                :actor="approvalRejectBy"
                :templates="overallRejectTemplates"
                :force-active="hasSelectedFieldReject"
                :rejected-count="selectedFieldRejectCount"
              />

              <CompanyRejectDetailsModal
                v-model="showRejectDetailsModal"
                :results="approvalContentResults"
                :rejected-time="approvalRejectedTime"
                :is-approval-mode="isApprovalMode"
              />

              <PublicTabs
                v-model="TabIndex"
                :TabList="TabList"
                :TabStyle="2"
                :Loading="loading"
                :IsHiddenRight="true"
                :IsSavePrompt="!isApprovalMode"
                :AutoSaveOnTabChange="true"
                :AlwaysAutoSaveOnTabChange="isApprovalMode && showProductRejectPanels"
                :PageLeaveType="PageLeaveType"
                :RightOnleftFooterShow="false"
                :ProgressValue="Number(Progress || 0)"
                @save="saveCompanyInfoFromTabChange"
                @submit="submitCompanyInfoFromTabChange"
              >
                <template v-slot:TabCardHead>
                  <div>
                    <span class="bCardTitle">{{ $t('lbl_EMPBE_CompanyInfo_Left_Title') }}</span>
                    <p class="bCardTitle_P">{{ $t('lbl_EMPBE_CompanyInfo_Left_Title_P') }}</p>
                  </div>
                </template>
                <template v-slot:TabCardFoot>
                  <LeftMenuFooter
                    :dataList="companyUnFillList"
                    :progressModel="companyProgressModel"
                    :selectedTabName="selectedTabName"
                    @selected="selectName"
                  />
                </template>
                <template v-slot:RightSlot>
                  <ProInfoUpdateTime
                    :submitDate="lastSubmitDate"
                    :approvalDate="displayApprovalActionTime"
                    :permissionData="permissionData"
                  />
                </template>
                <template v-slot:tab0>
                  <!-- 用 div 而非 fieldset：Chrome 下 fieldset+pointer-events:none 会吞掉子级 textarea 点击 -->
                  <div class="product-submit-fieldset" :class="{ 'is-approval-readonly': isApprovalMode }">
                    <basicInfo
                      ref="tab0"
                      :supplierId="companyid"
                      :SelectOptions="SelectOptions"
                      :submitType="submitType"
                    />
                  </div>
                </template>
                <template v-slot:tab1>
                  <div class="product-submit-fieldset" :class="{ 'is-approval-readonly': isApprovalMode }">
                    <sourcingRequestContact
                      ref="tab1"
                      :SelectOptions="SelectOptions"
                      :supplierId="companyid"
                      :submitType="submitType"
                      @uploadFinish="UploadFinish"
                    />
                  </div>
                </template>
                <template v-slot:tab2>
                  <div class="product-submit-fieldset" :class="{ 'is-approval-readonly': isApprovalMode }">
                    <logoAndImage
                      ref="tab2"
                      :SelectOptions="SelectOptions"
                      :supplierId="companyid"
                      :submitType="submitType"
                      @uploadFinish="UploadFinish"
                    />
                  </div>
                </template>
                <template v-slot:tab3>
                  <div class="product-submit-fieldset" :class="{ 'is-approval-readonly': isApprovalMode }">
                    <database
                      ref="tab3"
                      :supplierId="companyid"
                      :SelectOptions="SelectOptions"
                      :CompanyCertificationCount="CompanyCertificationCount"
                      :CompanyPhotoGalleryCount="CompanyPhotoGalleryCount"
                      :submitType="submitType"
                      @uploadFinish="UploadFinish"
                    />
                  </div>
                </template>
                <template v-slot:tab4>
                  <div class="product-submit-fieldset" :class="{ 'is-approval-readonly': isApprovalMode }">
                    <ClientList
                      ref="tab4"
                      :SelectOptions="SelectOptions"
                      :supplierId="companyid"
                      :submitType="submitType"
                      @uploadFinish="UploadFinish"
                    />
                  </div>
                </template>
              </PublicTabs>

              <div class="customizer-formbutton" v-if="!supplierId && !isApprovalMode">
                <b-button-group>
                  <!-- <button type="button" class="btn btn-light btn-lg" @click="GotoWebSite"
                    v-bind:t_label="'EMPBE_CompanyInfoCenter_GotoWebSite'">
                    <i class="fa fa-eye m-r-5"></i>{{$t("lbl_EMPBE_Preview")}}
                  </button> -->

                  <button :disabled="isSavingOrSubmiting" type="button" class="btn btn-primary btn-lg" @click="saveCompanyInfo"
                    v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSave_' + companyid">
                    <i class="fa fa-save m-r-5"></i>
                    <span v-if="isLastVisibleTab()">
                      {{ $t("lbl_EMPBE_CompanyInfo_Save") }}
                    </span>
                    <span v-else>
                      {{ $t("lbl_EMPBE_CompanyInfo_SaveDraft") }}
                    </span>
                  </button>
                  <button v-if="isUAT" type="button" class="btn btn-warning btn-lg" @click="btnSyncCompanyToFrontEnd_Click"
                    v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSyncCompanyToFrontEnd_' + companyid">
                    <i class="fa fa-refresh m-r-5"></i>{{ $t("Lbl_CompanySyncToFrontEnd") }} (Debug)
                  </button>
                  <button :disabled="isSavingOrSubmiting" type="button" class="btn btn-success btn-lg" @click="submitCompanyInfo" 
                    v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSubmit_' + companyid" >
                    <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_CompanyInfo_Submit") }}
                  </button>
                  <!-- <button type="button" class="btn btn-success btn-lg" @click="saveCompanyInfoAndNext"
                    v-if="TabIndex < (TabList.length-1)" v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSaveAndNext'"
                    >
                    <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_SaveAndNext") }}
                  </button> -->
                </b-button-group>
              </div>
            </b-form>
          </div>
        </div>
      </template>
    </visitorPermission>
  </div>
</template>
<script>
import { computed } from "vue";
import { CompanyInfoService, userService, productService, LogService } from "@/_services";
import { hasProductListDraftIndicator, PRODUCT_DISPLAY_STATUS, PRODUCT_LAUNCH_STATUS } from "@/_services/product.service";
import { mapGetters, mapState } from "vuex";

//--------------------------- tab ----------------------------------
import basicInfo from "./basicInfo.vue";
import sourcingRequestContact from "./sourcingRequestContact.vue";
import logoAndImage from "./logoAndImage.vue";
import database from "./database.vue";
import ClientList from "./ClientList.vue";

//--------------------------- PageCompanted ----------------------------------
// import PublicTabs from "../../components/PublicTabs/PublicTabs.vue";
import LeftMenuFooter from "../NewproductInfoCenter/Popup/LeftMeunFooter.vue";
import ProInfoUpdateTime from "../NewproductInfoCenter/Popup/ProInfoUpdateTime.vue";
import { AlertDialog } from "@/_helpers/AlertDialog";
import { viewportTooltip } from "@/_helpers/tooltip";
import { SHOW_EDIT_SUPPLIER_REJECT_REASON } from "@/constants/approvalRejectUi.js";
import companyApprovalMixin from "./companyApprovalMixin";

const defaultUploadResult = {
  isSuccessful: true,
  message: "",
  failedItems: [],
};

export default {
  mixins: [AlertDialog, companyApprovalMixin],
  components: {
    basicInfo,
    sourcingRequestContact,
    logoAndImage,
    database,
    LeftMenuFooter,
    ProInfoUpdateTime,
    ClientList,
  },
  beforeRouteLeave(to, from, next) {
    if (!this.$store.state.dirty) {
      next();
      return;
    }
    const { title, text, confirmBtn } = this.getPageLeaveDialogContent();
    this.showLeavePageAfterSave(title, text, confirmBtn).then((result) => {
      this.handlePageLeaveAction(result, next);
    });
  },
  provide() {
    return {
      permissionData: computed(() => this.permissionData),
      companyApprovalHost: this,
    };
  },
  props: {
    supplierId: { default: null },
    submitType: { type: String, default: 'edit' },
  },
  data() {
    return {
      TabIndex:0,
      iconOpenInNew: require('@/assets/images/icon-open-in-new.svg'),
      TabList:[
        {name:this.$t('lbl_EMPBE_CompanyInfo_Tab_First_Name'),status:0,t_label:"EMPBE_CompanyInfoCentera",IsShow:true,ProgressPage:'BasicInfo'},
        {name:this.$t('lbl_EMPBE_CompanyInfo_Tab_Seconed_Name'),status:0,t_label:"EMPBE_CompanyInfoCenterb",IsShow:true,ProgressPage:'ContactAndEnquiry'},
        {name:this.$t('lbl_EMPBE_CompanyInfo_Tab_Thred_Name'),status:0,t_label:"EMPBE_CompanyInfoCenterc",IsShow:true,ProgressPage:'CustomisedEBooth'},
        {name:this.$t('lbl_EMPBE_CompanyInfo_Tab_Four_Name'),status:0,t_label:"EMPBE_CompanyInfoCenterd",IsShow:true,ProgressPage:'Certification'},
        {name:this.$t('lbl_EMPBE_CompanyInfo_Tab_Five_Name'),status:0,t_label:"EMPBE_CompanyInfoCentere",IsShow:true,ProgressPage:'OurClient'},
      ],
      permissionData: null,
      loading: false,
      lastUpdateDate: "-",
      lastSubmitDate: "-",
      Progress:0,
      CompanyCertificationCount: 0,
      CompanyPhotoGalleryCount: 0,
      SelectOptions:
      {
          //CheckAppAndCatOptions:[],           //检测产品类别和应用行业的内容,改为实时获取
          TargetMarketsOptions:[],            //目标市场列表
          CellCountryOptions: [],             //国家区号列表
          CountryOptions: [],                 //国家列表
          CurrencyUnitOptions: [],            //货币单位列表
          BusinessNatureOptions:[],           //业务性质列表
          IndustriesOptions:[],               //主要和其他 应用行业列表
          //ProductCategoriesOptions:[],        //主要产品分类列表
          MstCategoriesOptions:[],            //产品类别(所有)
          OfficeQtyOptionsBySpaceMaster:[],   //辦公室數量
          OfficeQtyOptionsBySpaceFoot:[],     //辦公室數量
          EmployeesOptions:[],                //员工人数列表
          AnnualSalesRevenueOptions:[],       //年度销售额列表
          UnitsOfAreaOptions:[],              //面积单位列表
          MarketOptions:[],                   //市场列表
          ListingOfSecuritiesCompanies:[],    //证券上市公司列表
          NatureOptions:[],                   //性质列表
          SRSNOptions:[],                     //SRSN列表  
          SRUILevelOptions:[],                //專新特新等級   
          CertificationTypeOptions:[],        //资质类型列表
          ProvOptions:[],                     //省列表
          EboothSample:
          [
          { 
            "EmpCompanyId": 1049988,
            "Grade": "A",
            "companyUrl": "https://www.chinaplasonline.com/eMarketplace/ExhibitorInfo/?compid=1049988" 
          }
          ]

      },
       isDataLoaded:false,
      
      isSavingOrSubmiting: false,

      uploadResult: { ...defaultUploadResult },
      stickyLayoutOffsets: {
        contentTop: 64,
        leftTop: 128,
        mainOffsetLeft: 0,
        headerOffsetLeft: 0,
        formWidth: 1167,
        formLeft: 0,
      },
      pageBodyResizeObserver: null,
      selectedTabName: '',
      companyUnFillList: [],
      PageLeaveContent: {
        SubmitTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
        SubmitText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
        SubmitConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Submit'),
        SaveTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
        SaveText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
        SaveConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Save'),
      },
    };
  },
  computed: {
    ...mapState("submitFormMessage", { isShowSubmitAlertMessage : "isShowModal" }),

    ...mapGetters({
      getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? this.user.empCompanyId
        : this.supplierId;
    },
    canViewLive() {
      return this.launchStatus === PRODUCT_LAUNCH_STATUS.online;
    },
    /** 供应商端：仅 SHOW_EDIT_SUPPLIER_REJECT_REASON 打开时显示「更多动作」 */
    showSupplierMoreAction() {
      return !!SHOW_EDIT_SUPPLIER_REJECT_REASON;
    },
    /** 管理员菜单始终可点开；供应商菜单由 v-if 控制显隐，无需再 disabled */
    isMoreActionDisabled() {
      return false;
    },
    IsHiddenRightMenu(){
      return this.user.userType === "ADMIN"
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    GetTabRef()
    {
      return "tab"+this.TabIndex;
    },
    isUAT() {
      return process.env.VUE_APP_EMP_IsUat === 'true' || process.env.VUE_APP_EMP_IsUat === '1';
    },
    hasSubmittedBefore() {
      return this.lastSubmitDate && this.lastSubmitDate !== '-';
    },
    PageLeaveType() {
      return this.hasSubmittedBefore ? 1 : 2;
    },
    isAdminViewingSupplier() {
      return this.supplierId !== null
        && this.supplierId !== undefined
        && this.supplierId !== '';
    },
    companyProgressModel() {
      return { progress: this.Progress || 0 };
    },
    formDynamicStyle() {
      if (this.fromAdmin) {
        return {
          '--np-admin-left-top': `${this.stickyLayoutOffsets.leftTop}px`,
        };
      }
      return {
        '--np-content-top': `${this.stickyLayoutOffsets.contentTop}px`,
        '--np-left-top': `${this.stickyLayoutOffsets.leftTop}px`,
        '--np-main-offset-left': `${this.stickyLayoutOffsets.mainOffsetLeft}px`,
        '--np-header-offset-left': `${this.stickyLayoutOffsets.headerOffsetLeft}px`,
        '--np-form-width': `${this.stickyLayoutOffsets.formWidth}px`,
        '--np-form-left': `${this.stickyLayoutOffsets.formLeft}px`,
      };
    },
    showDraftBanner() {
      return hasProductListDraftIndicator({
        displayStatus: this.displayApprovalStatus,
        lastSaveDate: this.lastUpdateDate,
        lastSubmitDate: this.lastSubmitDate,
      }) && !this.fromAdmin;
    },
    GetLiList() {
      const isOnline = this.launchStatus === PRODUCT_LAUNCH_STATUS.online;
      const reviewStatus = this.displayApprovalStatus;
      const isPending = reviewStatus === PRODUCT_DISPLAY_STATUS.pending
        || reviewStatus === PRODUCT_DISPLAY_STATUS.pendingManualAudit;
      const isDraft = reviewStatus === PRODUCT_DISPLAY_STATUS.toBeSubmitted;

      // 默认：未上架 / 草稿 / 审批中 → 下架不可用
      const delistDisabled = !isOnline || isDraft || isPending;

      // 管理员编辑/审批：开关关闭时隐藏「下架」（仍可显示切换模式）
      const showDelist = !this.fromAdmin || !!SHOW_EDIT_SUPPLIER_REJECT_REASON;

      const delistItem = {
        name: this.$t('lbl_EMPBE_Delist'),
        eventName: 'Delist',
        status: 0,
        disabled: delistDisabled,
        iconClass: 'fa fa-eye-slash graybg',
      };

      if (this.fromAdmin) {
        const items = [{
          name: this.isApprovalMode
            ? this.$t('lbl_EMPBE_SwitchToEditMode')
            : this.$t('lbl_EMPBE_SwitchEditApprovalMode'),
          eventName: 'SwitchMode',
          status: 0,
          disabled: !this.isApprovalMode && isDraft,
          iconClass: 'fa fa-external-link graybg',
        }];
        if (showDelist) items.push(delistItem);
        return items;
      }

      // 供应商端：菜单显隐由 showSupplierMoreAction 控制
      return [delistItem];
    },
  },
  watch: {
    supplierId: {
      handler() {
        this.InitData();
      },
      deep: true,
    },
    TabIndex(newIndex, oldIndex) {
      if (newIndex === oldIndex) return;
      const tab = this.TabList[newIndex];
      if (tab && tab.ProgressPage) {
        this.selectedTabName = tab.ProgressPage;
      }
      this.recordCompanyInfoView(newIndex);
    },
    permissionData()
    {
      this.GetTabShows();
    },
    
    isShowSubmitAlertMessage: {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue === true) {
          this.AfterHideMessageModal();
        }
      }
    },
    showProductRejectPanels() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    rejectedApprovalCount() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    statusLoaded() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    showDraftBanner() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
  },
  created() {
    if (this.$route.query.TabIndex) {
      this.TabIndex = this.$route.query.TabIndex;
      this.$router.replace({ name: 'Report' });
    }
  },
  mounted() {
    this.InitData();
    this.$nextTick(() => {
      const headerEl = this.$refs.stickyHeader;
      if (headerEl) {
        headerEl.style.width = '';
        headerEl.style.left = '';
      }
      this.recordCompanyInfoView(this.TabIndex);
      this.refreshStickyLayoutOffsets();
    });
    window.addEventListener('resize', this.refreshStickyLayoutOffsets);
    this.bindPageBodyResizeObserver();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.refreshStickyLayoutOffsets);
    if (this.pageBodyResizeObserver) {
      this.pageBodyResizeObserver.disconnect();
      this.pageBodyResizeObserver = null;
    }
  },
  methods: 
  {
    viewportTooltip,
    viewLiveTooltipConfig() {
      return viewportTooltip(this.$t('lbl_EMPBE_ViewPublishedVersion_Tooltip'));
    },
    bindPageBodyResizeObserver() {
      if (typeof ResizeObserver === 'undefined') return;
      const pageBody = document.querySelector('.page-body');
      const formEl = document.getElementById('companyInfoForm');
      if (!pageBody && !formEl) return;
      this.pageBodyResizeObserver = new ResizeObserver(() => {
        this.refreshStickyLayoutOffsets();
      });
      if (pageBody) this.pageBodyResizeObserver.observe(pageBody);
      if (formEl) this.pageBodyResizeObserver.observe(formEl);
    },
    refreshStickyLayoutOffsets() {
      const headerEl = this.$refs.stickyHeader;
      const formEl = document.getElementById('companyInfoForm');
      if (!headerEl || !headerEl.offsetHeight || !formEl) return;
      const formRect = formEl.getBoundingClientRect();
      const headerHeight = headerEl.offsetHeight;
      const pageBody = document.querySelector('.page-body');
      const mainOffsetLeft = pageBody ? pageBody.getBoundingClientRect().left : 0;
      const headerOffsetLeft = headerEl.getBoundingClientRect().left;
      if (this.fromAdmin) {
        // 与产品页一致：左侧吸顶位置紧贴 sticky 页头底边，避免滚动时被页头遮住
        this.stickyLayoutOffsets = {
          contentTop: headerHeight,
          leftTop: Math.max(1, headerHeight),
          mainOffsetLeft,
          headerOffsetLeft,
          formWidth: formRect.width,
          formLeft: formRect.left,
        };
        return;
      }
      // 与 productDetail 同一套对齐：右栏 padding-top = headerHeight-24，左栏 fixed top = headerHeight+40（相差 64px）
      const contentTop = Math.max(0, headerHeight - 24);
      const leftTop = Math.max(0, headerHeight + 40);
      this.stickyLayoutOffsets = {
        contentTop,
        leftTop,
        mainOffsetLeft,
        headerOffsetLeft,
        formWidth: formRect.width,
        formLeft: formRect.left,
      };
    },
    formatCompanyDateTime(date) {
      const d = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    refreshDraftBannerTimestamps() {
      const next = this.formatCompanyDateTime(new Date());
      if (next) this.lastUpdateDate = next;
    },
    GetPageTitleName() {
      return this.$t('lbl_EMPBE_CompanyInfo');
    },
    selectName(tabName) {
      const tabIndex = this.TabList.findIndex((item) => item.ProgressPage === tabName);
      if (tabIndex !== -1) {
        this.nextTabSaveOrSubmit(tabIndex);
      }
    },
    /** 左侧步骤 / 分区切换：有改动则先保存再切（与产品 nextTabSaveOrSubmit 一致） */
    nextTabSaveOrSubmit(tabidx) {
      if (this.isApprovalMode) {
        if (!this.showProductRejectPanels) {
          this.TabIndex = tabidx;
          this.selectedTabName = this.TabList[tabidx]?.ProgressPage || '';
          return;
        }
        this.saveCompanyInfoFromTabChange(tabidx);
        return;
      }
      if (this.$store.state.dirty) {
        this.saveCompanyInfoFromTabChange(tabidx);
      } else {
        this.TabIndex = tabidx;
        this.selectedTabName = this.TabList[tabidx]?.ProgressPage || '';
      }
    },
    UploadFinish(failedFilesFields) {
      const isSuccess = failedFilesFields.length === 0;

      this.uploadResult.isSuccessful = isSuccess;
      this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];

      this.$submitFormMessage.FinishUploadPopup({ isSuccess });
    },


    SaveFinish(isSuccess) {
      this.$submitFormMessage.NextStepSubmitMessagePopup({ isCurrentStepFailed: !isSuccess });
    },

    closeSubmitProgressModal() {
      this.$submitFormMessage.HideMessagePopup();
    },

    ShowResultMessagePopup(isSuccess, message, isSubmit, missingFields = [], header = '') {
      const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
      const uploadFailedItems = this.uploadResult.failedItems;

      this.$submitFormMessage.ShowResultPopup({
        isSuccess: isSuccessful,
        message,
        isSubmit,
        missingFields,
        uploadFailedItems,
        header,
      });
    },

    AfterHideMessageModal() {
      this.uploadResult = { ...defaultUploadResult };
    },

    GotoWebSite() {
      this.todoViewLive();
    },
    todoViewLive() {
      if (!this.canViewLive) return;
      const base = (process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/').replace(/\/?$/, '/');
      const langId = String(localStorage.getItem('currentLangId') || this.langid || '936');
      let langSegment = 'simp';
      if (langId === '950') langSegment = 'trad';
      else if (langId === '1252') langSegment = 'eng';
      window.open(`${base}ExhibitorInfo/${langSegment}?compid=${this.companyid}`, '_blank');
    },
    switchAdminEditApprovalMode() {
      if (!this.fromAdmin) return;
      if (!this.isApprovalMode && this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.toBeSubmitted) {
        return;
      }
      const accountId = this.companyid;
      if (!accountId) return;

      this.confirmSwitchAdminMode(this.isApprovalMode).then((res) => {
        if (!res.isConfirmed) return;

        const path = this.isApprovalMode
          ? '/Management/supplier'
          : '/Management/CompanyApproval';
        const { href } = this.$router.resolve({
          path,
          query: {
            companyId: String(accountId),
            tab: 'company',
          },
        });
        window.open(href, '_blank');
      });
    },
    handleMoreAction(event) {
      if (!event || event.disabled) return;
      if (event.eventName === 'SwitchMode') {
        this.switchAdminEditApprovalMode();
      } else if (event.eventName === 'Delist') {
        this.todoDelistCompany();
      }
    },
    todoDelistCompany() {
      if (this.launchStatus !== PRODUCT_LAUNCH_STATUS.online) return;
      this.$swal({
        title: this.$t('lbl_EMPBE_Delist'),
        showCancelButton: true,
        confirmButtonText: this.$t('lbl_EMPBE_Delist'),
        cancelButtonText: this.$t('lbl_EMPBE_Cancel'),
        confirmButtonColor: '#DC3545',
        reverseButtons: true,
        customClass: 'AlertDialog-DEL',
      }).then(async (res) => {
        if (!res.isConfirmed) return;
        try {
          const delistRes = await CompanyInfoService.DelistCompany({ companyId: this.companyid });
          this.$submitFormMessage.ShowMesaagePopup({
            title: delistRes.isSuccessful
              ? this.$t('lbl_EMPBE_DelistSuccess')
              : this.$t('lbl_EMPBE_DelistFailed'),
          });
          if (delistRes.isSuccessful) {
            this.companyIsLaunch = 0;
            await this.LoadApprovalStatus();
          }
        } catch (e) {
          this.$submitFormMessage.ShowMesaagePopup({
            title: this.$t('lbl_EMPBE_DelistFailed'),
          });
        }
      });
    },
    resolveCompanyInfoViewFormType(tabIndex) {
      const map = {
        0: 'Company_BasicInfo',
        1: 'Company_Contact',
        2: 'Company_eBooth',
        3: 'Company_Cert',
        4: 'Company_ClientList',
      };
      return map[tabIndex] || null;
    },
    recordCompanyInfoView(tabIndex) {
      if (!this.isAdminViewingSupplier) return;
      const formType = this.resolveCompanyInfoViewFormType(tabIndex);
      const companyId = Number(this.companyid);
      if (!formType || !Number.isFinite(companyId) || companyId <= 0) return;
      LogService.LogFormData({
        FormId: companyId,
        EmpCompanyId: companyId,
        Action: 'Open',
        FormType: formType,
        FormJSON: JSON.stringify({
          tabIndex,
          targetCompanyId: companyId,
          simulatedSupplierView: true,
        }),
        ErrorLog: null,
      }).catch(() => {});
    },
    InitData() {
      this.loading = true;
      this.GetSysCompanySponsorType();
      this.loadData().then(() => this.loadCompanyApprovalIfNeeded().finally(() => {
        this.$nextTick(() => this.refreshStickyLayoutOffsets());
      }));
      this.GetOptions();
      this.GetOptionsAsync();
    },
    //重新初始话当前子组件方法
    LoadingChildPage()
    {
      this.$refs[this.GetTabRef].InitData();
    },
    //子组件保存
    SaveChildPage()
    {
      //返回状态的目的是为了确保子组件的内容已经提交通过
        return new Promise((resolve, reject) => {
          this.$refs[this.GetTabRef].Save().then(res=>{
            resolve(res);
          }).catch(err => {
            reject(err);
          });
      });
    },
    //子组件提交
    SubmitChildPage()
    {
      //返回状态的目的是为了确保子组件的内容已经提交通过
      return new Promise((resolve, reject) => {
          this.$refs[this.GetTabRef].Submit().then(res=>{
            resolve(res);
          }).catch(err => {
            reject(err);
          });
      });
    },
    //获取权限内容
    GetSysCompanySponsorType() {
      var that = this;
      if (this.companyid > 0) {
        userService
          .GetSysCompanySponsorType({ CompanyId: this.companyid })
          .then((res) => {
            if (res.isSuccessful) {
              var data = res.data;
              that.permissionData = this.getPermissionJsonByUser({ user: data });
              if (that.permissionData != null) {
                that.CompanyCertificationCount = that.permissionData.CompanyCertificationCount;
                that.CompanyPhotoGalleryCount = that.permissionData.CompanyPhotoGalleryCount;
              }
            }
          });
      }
    },
    //获取tab的可显状态
    GetTabShows()
    {
        this.TabList.forEach((element, index) => {
          element.IsShow= ! this.isHastype(index)
        });
    },
    isHastype(index)
    {
      var isHastype=false;
      switch  (index) {
        case 3:
          // isHastype= this.permissionData != null ? ["Guest"].includes(this.permissionData['Type']):false;
          break;
        case 4:
          isHastype= this.permissionData != null ? !['A+','A','B','C'].includes(this.permissionData['Type']):true;
          break;
        default:
        break;
      }
      return isHastype;
    },
    //获取leftmemu 及 rightmenu 数据
    loadData() {
      this.loading = true;
      var parms = { companyId: this.companyid };
      return CompanyInfoService.GetCompanyOtherInfo(parms).then((res) => {
        if (res.isSuccessful) {
          if(res.data?.record?.lastSubmitDate)
          {
            const [datePart, timePart] = res.data?.record?.lastSubmitDate.split(' ');
            const [hours, minutes] = timePart.split(':').slice(0, 2);
            this.lastSubmitDate = `${datePart} ${hours}:${minutes}`;
          }
          if(res.data?.record?.lastSaveDate)
          {
            const [datePart, timePart] = res.data?.record?.lastSaveDate.split(' ');
            const [hours, minutes] = timePart.split(':').slice(0, 2);
            this.lastUpdateDate = `${datePart} ${hours}:${minutes}`;
          }
          this.Progress=res.data?.progress?.progress >100 ? 100 : parseInt(res.data?.progress?.progress);
          const progressFlags = [
            res.data?.progress?.isBusinessProfileFinished,
            res.data?.progress?.isContactFinished,
            res.data?.progress?.iseBoothFinished,
            res.data?.progress?.isCertificationFinished,
            res.data?.progress?.isClientListFinished,
          ];
          progressFlags.forEach((finished, idx) => {
            if (!this.TabList[idx]) return;
            const hasUnfilled = finished != 1;
            this.$set(this.TabList[idx], '_hasUnfilledRequired', hasUnfilled);
            this.$set(this.TabList[idx], 'status', hasUnfilled ? 1 : 0);
          });
          this.refreshTabExclamationMarks();
        }
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    //获取子项需要的选项列表 防止每一个子页面重复调用
    async GetOptions()
    {

        // //检测产品类别和应用行业的内容
        //   CompanyInfoService.GetProductAndAdCheckItem({CompId:this.companyid,langId:this.langid}).then((response) => {
        //   if (response.isSuccessful) {
        //     this.SelectOptions.CheckAppAndCatOptions = response.data;
        //   }
        // });
        //获取国家区号
        this.SelectOptions.CellCountryOptions = (await CompanyInfoService.GetCellCountryData()).map(item=>{
          return {
            id: item.Code,
            label: item.Name
          }
        }); 

        //国家列表
        CompanyInfoService.GetCountryList().then((response) => {
          if (response.isSuccessful) {
            var dataList = response.data;
            this.SelectOptions.CountryOptions = dataList;
          }
        });

        //获取省区options
        CompanyInfoService.GetCompanyRegions(this.langid,"ExportMarket").then((response) => {
          if (response.isSuccessful) {
            this.SelectOptions.TargetMarketsOptions = JSON.parse(response.data.lVjSON);
          }
        });
        //获取省区options
        CompanyInfoService.GetProvList().then((response) => {
          if (response.isSuccessful) {
            this.SelectOptions.ProvOptions = response.data.map(item=>(
              {
                id:item.provId,
                label: (this.langid == 936) ? item.provNameS : ( this.langid==1252 ?  item.provNameE : item.provNameT)
              }
            ));
          }
        });

        //主要应用列表和其他应用产品列表
        CompanyInfoService.GetIndustryList().then((response) => {
          if (response.isSuccessful) {
            var dataList = response.data;
            this.SelectOptions.IndustriesOptions = dataList;
          }
        });

        //主要产品列表和其他产品列表
        // CompanyInfoService.GetProductCatList().then((response) => {

        //   //加行业
        //   if (response.isSuccessful) {
        //     var dataList = response.data;
        //     //删除空对象

        //     var y = dataList;
        //     var keyCount = Object.keys(y).length;
        //     for (var i = 0; i < keyCount; i++) {
        //       var questionCount = dataList[i]["children"].length;
        //       if (questionCount == 0) {
        //         delete dataList[i]["children"]; //删除主目录没有 子项的arrary属性，例如：其他项
        //       }
        //       for (let j = 0; j < questionCount; j++) {
        //         var emptyquestion = dataList[i]["children"][j]["children"].length;
        //         if (emptyquestion === 0) {
        //           delete dataList[i]["children"][j].children;
        //         }
        //         var questionobj = null;
        //         var questionCount2 = 0;
        //         if (dataList[i]["children"][j].hasOwnProperty("children")) {
        //           questionobj = dataList[i]["children"][j]["children"];
        //           if (questionobj != null) {
        //             questionCount2 = dataList[i]["children"][j]["children"].length;
        //           }
        //         }

        //         for (let k = 0; k < questionCount2; k++) {
        //           var emptyquestion =
        //             dataList[i]["children"][j]["children"][k]["children"].length;
        //           if (emptyquestion == 0) {
        //             //delete (dataList[i]['children'][j]['children'][k]);
        //             delete dataList[i]["children"][j]["children"][k].children;
        //           }
        //         }
        //       }
        //     }

        //     this.SelectOptions.ProductCategoriesOptions = dataList;
        //   }
        // });

        //产品类别：新版
        CompanyInfoService.GetAllProductCategories().then((response) => {
          //  console.log('GetAllProductCategories');
          //加行业
          if (response.isSuccessful) {
            var dataList = response.data; 
            // console.log('GetAllProductCategories'+dataList.length);
            this.SelectOptions.MstCategoriesOptions = dataList;
             this.isDataLoaded=true;
          }
        });
 
    },
    async GetOptionsAsync()
    {
        const AllOptions = await this.GetMutipleMstKeyValueMapping("SalesRevenueAmount,CompanyBusniessNature,Employee,OfficeSpaceMeters,OfficeSpaceFoot,SalesRevenue,OfficeSpaceUnit,ExportMarket,OfficesNature,StockExchanges,SRUILevel,CompanyCertifiationType","code","text");
        // console.log('AllOptions',AllOptions);
        //货币单位列表
        this.SelectOptions.CurrencyUnitOptions= AllOptions.filter(item => item.type?.toLowerCase() === "SalesRevenueAmount".toLowerCase());
        //业务性质列表
        this.SelectOptions.BusinessNatureOptions= AllOptions.filter(item => item.type?.toLowerCase() === "CompanyBusniessNature".toLowerCase());
        //员工人数列表
        this.SelectOptions.EmployeesOptions= AllOptions.filter(item => item.type?.toLowerCase() === "Employee".toLowerCase());
        //辦公室數量
        this.SelectOptions.OfficeQtyOptionsBySpaceMaster= AllOptions.filter(item => item.type?.toLowerCase() === "OfficeSpaceMeters".toLowerCase());
        //辦公室數量
        this.SelectOptions.OfficeQtyOptionsBySpaceFoot= AllOptions.filter(item => item.type?.toLowerCase() === "OfficeSpaceFoot".toLowerCase());
        //年度销售额列表
        this.SelectOptions.AnnualSalesRevenueOptions= AllOptions.filter(item => item.type?.toLowerCase() === "SalesRevenue".toLowerCase());

        //面积单位列表
        const HasCode = ["1","5"];
        this.SelectOptions.UnitsOfAreaOptions= AllOptions.filter(item => item.type?.toLowerCase() === "OfficeSpaceUnit".toLowerCase()).filter(item => HasCode.includes(item.id));;
        //市场类型列表
        this.SelectOptions.MarketOptions= AllOptions.filter(item => item.type?.toLowerCase() === "ExportMarket".toLowerCase());

        this.SelectOptions.NatureOptions= AllOptions.filter(item => item.type?.toLowerCase() === "OfficesNature".toLowerCase());
        //证券上市公司列表
        this.SelectOptions.SRSNOptions= AllOptions.filter(item => item.type?.toLowerCase() === "StockExchanges".toLowerCase());


        //專新特新等級
        this.SelectOptions.SRUILevelOptions= AllOptions.filter(item => item.type?.toLowerCase() === "SRUILevel".toLowerCase());
        //资质类型列表
        this.SelectOptions.CertificationTypeOptions= AllOptions.filter(item => item.type?.toLowerCase() === "CompanyCertifiationType".toLowerCase());

        //  console.log('SelectOptions',this.SelectOptions);

      /*
        //货币单位列表
        this.SelectOptions.CurrencyUnitOptions= await this.GetMstKeyValueMappingsApi("SalesRevenueAmount","code","text");
        //业务性质列表
        this.SelectOptions.BusinessNatureOptions= await this.GetMstKeyValueMappingsApi("CompanyBusniessNature","code","text");
        //员工人数列表
        this.SelectOptions.EmployeesOptions= await this.GetMstKeyValueMappingsApi("Employee","code","text");
        //辦公室數量
        this.SelectOptions.OfficeQtyOptionsBySpaceMaster= await this.GetMstKeyValueMappingsApi("OfficeSpaceMeters","code","text");
        //辦公室數量
        this.SelectOptions.OfficeQtyOptionsBySpaceFoot= await this.GetMstKeyValueMappingsApi("OfficeSpaceFoot","code","text");
        //年度销售额列表
        this.SelectOptions.AnnualSalesRevenueOptions= await this.GetMstKeyValueMappingsApi("SalesRevenue","code","text");
        //面积单位列表
        const HasCode = ["1","5"]
        this.SelectOptions.UnitsOfAreaOptions= (await this.GetMstKeyValueMappingsApi("OfficeSpaceUnit","code","text")).filter(item=>HasCode.includes(item.id));
        //市场类型列表
        this.SelectOptions.MarketOptions= await this.GetMstKeyValueMappingsApi("ExportMarket","code","text");
        //证券上市公司列表

        //性质列表
        this.SelectOptions.NatureOptions= await this.GetMstKeyValueMappingsApi("OfficesNature","code","text");
        //SRSN列表
        this.SelectOptions.SRSNOptions= await this.GetMstKeyValueMappingsApi("StockExchanges","code","text");
        //專新特新等級
        this.SelectOptions.SRUILevelOptions= await this.GetMstKeyValueMappingsApi("SRUILevel","code","text");
        //资质类型列表
        this.SelectOptions.CertificationTypeOptions= await this.GetMstKeyValueMappingsApi("CompanyCertifiationType","code","text");
      */
    },



    async GetMutipleMstKeyValueMapping(MstKeytype,code,text)
    {
      var data =[];
      await productService
          .GetMutipleMstKeyValueMapping({ type:MstKeytype, langId: this.langid })
          .then((res) => {
          if (res.isSuccessful) {
            // console.log('GetMutipleMstKeyValueMapping',res.data);
            data = res.data.map(item=>({
              type:item["type"],
              id:item[code],
              label:item[text]
            }))
          }
        });
        return data;
    },
    //获取MstKeyValueMappings相关数据
    async GetMstKeyValueMappingsApi(MstKeytype,code,text)
    {
      var data =[];
      await productService
          .GetMstKeyValueMapping({ type:MstKeytype, langId: this.langid })
          .then((res) => {
          if (res.isSuccessful) {
            data = res.data.map(item=>({
                    id:item[code],
                    label:item[text]
            }))
          }
        });
        return data;
    },
    // cancelCompanyInfo() {
    //   this.$swal({
    //     //Show Alert
    //     text: this.$t("lbl_EMPBE_AreYouSureToCancel"),
    //     showCancelButton: true,
    //     confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
    //     cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
    //   }).then((res) => {
    //     if (res.isConfirmed) {
    //       this.loadData();
    //       //this.LoadingChildPage();
    //     }
    //   });
    // },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.companyid,
        PageName: this.$route.path.split("/")[1],
        Action: action,
      }, errorLogObj);
    },

    isLastVisibleTab() {
      if (this.TabList[this.TabList.length - 1].IsShow) {
        return true;
      }
      return false;
    },

    saveCompanyInfo() {
      this.isSavingOrSubmiting = true;
      this.SaveChildPage().then(res => {
        if (!res.isSuccessful) {
          this.SaveFinish(false);
          this.ShowResultMessagePopup(false, res.popupAlertMsg || this.$t("lbl_EMPBE_Save_Failed"), false);
          return;
        }

        this.refreshDraftBannerTimestamps();

        // 管理员 / 最后一个可见 Tab：保存成功后询问是否立即提交（与产品资料 LastSave 一致）
        if (this.fromAdmin || this.isLastVisibleTab()) {
          this.SaveFinish(true);
          this.$submitFormMessage.HideMessagePopup();
          this.showSaveSucess(
            this.$t("lbl_EMPBE_Save_Success"),
            this.$t("lbl_EMPBE_CompanyInfo_Submit_Body")
          ).then(swalRes => {
            this.loadData();
            if (swalRes.isConfirmed) {
              this.submitCompanyInfo();
            }
          });
          return;
        }

        this.ShowResultMessagePopup(true, res.popupAlertMsg || this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"), false);
        this.PageNext();
        this.loadData();
      }).catch(err => {
        this.SaveFinish(false);
        this.ShowResultMessagePopup(false, err.popupAlertMsg || this.$t("lbl_emp2_PopupFailedBody"), false);
        if (err.error) {
          console.error(err.error);
        }
      }).finally(() => {
        this.isSavingOrSubmiting = false;
      });
    },
    // async saveCompanyInfoAndNext() 
    // {
    //   this.$swal({
    //     //Show Alert
    //     text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
    //     showCancelButton: true,
    //     type: "confirm",
    //     showConfirmButton: true,
    //     confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
    //     cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
    //   }).then(async (res) => {
    //     if (res.isConfirmed) 
    //     {
    //       this.SubmitChildPage().then(res=>{
    //         if(res)
    //         {
    //               CompanyInfoService.SubmitCompanyInfo({empCompanyId:this.companyid}).then(res=>{
    //                 if(res.isSuccessful)
    //                 {
    //                   this.loadData();
    //                   //this.LoadingChildPage();
    //                 }
    //           });
    //         }
    //       }).catch((err) => {
    //         console.error(err);
    //         if (this.$refs[this.GetTabRef]) {
    //           this.$refs[this.GetTabRef].loading = false;
    //         }
    //         this.ShowResultMessagePopup(false, err.message || this.$t('lbl_emp2_PopupFailedTitle'), true);
    //       });
    //     }
    //   });
    // },
    async btnSyncCompanyToFrontEnd_Click() {
      this.$swal({
        text: this.$t("lbl_EMPBE_AreYouSureToSyncCompanyToFrontEnd"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          CompanyInfoService.SyncCompanyToFrontEnd({
            delimitedCompanyIds: String(this.companyid)
          }).then(result => {
            if (result.isSuccessful) {
              this.ShowResultMessagePopup(true, this.$t("Lbl_CompanySyncToFrontEnd_Success"), false);
            } else {
              const msg = result.msg && result.msg.length ? result.msg.join('; ') : this.$t("Lbl_CompanySyncToFrontEnd_Failed");
              this.ShowResultMessagePopup(false, msg, false);
            }
          }).catch(err => {
            console.error('SyncCompanyToFrontEnd error:', err);
            this.ShowResultMessagePopup(false, this.$t("Lbl_CompanySyncToFrontEnd_Failed"), false);
          });
        }
      });
    },
    submitCompanyInfo() {
      // this.$swal({
      //   //Show Alert
      //   text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
      //   showCancelButton: true,
      //   type: "confirm",
      //   showConfirmButton: true,
      //   confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
      //   cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      // }).then(async (res) => {
      //   if (res.isConfirmed) 
      //   {
          //先执行 save 在提交
          this.isSavingOrSubmiting = true;
          this.SubmitChildPage().then(async (res) => {
            if (res.isSuccessful) {
              const submitCompany = () => {
                CompanyInfoService.SubmitCompanyInfo({
                  empCompanyId: this.companyid,
                  isAdminSubmit: !!this.fromAdmin,
                  skipAiApproval: process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() === 'ai',
                }).then(submitRes => {
                  if (submitRes.isSuccessful) {
                    this.ShowResultMessagePopup(
                      true,
                      this.$t('lbl_EMPBE_Company_SubmitSuccess_Body'),
                      true,
                      [],
                      this.$t('lbl_EMPBE_Company_SubmitSuccess_Title'),
                    );
                    this.loadData().then(() => this.LoadApprovalStatus());
                  } else {
                    this.LogPageFormError(submitRes, "Submit_SubmitCompanyInfo");
                    this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: submitRes.statusCode, msg: submitRes.msg?.join(",") || "Error" }), true);
                  }
                }).catch(err => {
                  //this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_SubmitAlert_SubmitFailedMsg"), true);
                  this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Submit_SubmitCompanyInfo");
                  console.error(err);
                });
              };

              // AI 环境：无条件整单提交
              if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() == 'ai') {
                this.SaveFinish(true);
                submitCompany();
                return;
              }

              await this.loadData();

              // 仅验证「未填必填」Tab，不把字段驳回提示计入提交失败列表
              var nameList = this.TabList.map((item, i) => {
                return {
                  sequenceNums: i,
                  hasUnfilledRequired: !!item._hasUnfilledRequired,
                  name: item.name
                };
              }).filter((item) => item.hasUnfilledRequired).map(item => `(${item.sequenceNums + 1}) ${item.name}`);

              if (res.isAllMandatoryFieldFilled === false) {
                const currIdx = this.TabIndex;
                const currTab = this.TabList[currIdx];
                const isAdded = nameList.some(item => item.includes(`(${currIdx + 1}) ${currTab.name}`));

                if (!isAdded) {
                  nameList.push(`(${currIdx + 1}) ${currTab.name}`);
                }
              }

              this.SaveFinish(true);

              if (nameList.length > 0) {
                this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_SubmitAlert_SubmitFailedMsg"), true, nameList);
                return;
              }

              submitCompany();
            } else {
              this.LogFormError(JSON.stringify({ res }), "Submit_SubmitChildPage");
              this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_SubmitAlert_SubmitFailedMsg"), true);
            }
          }).catch((err) => {
            console.error(err);
            this.LogFormError(JSON.stringify({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }), "Submit_SubmitChildPage");
            this.ShowResultMessagePopup(false, err.popupAlertMsg || this.$t('lbl_emp2_PopupFailedTitle'), true);
          }).finally(() => {
            this.isSavingOrSubmiting = false;
          });
      //   }
      // }); 
    },
    //跳下一页
    PageNext()
    {
      for(var i=0;i<this.TabList.length;i++)
      {
        if(i>this.TabIndex && this.TabList[i].IsShow)
            {
                this.TabIndex=i;
                break;
            }
      }
    },
    getPageLeaveDialogContent() {
      if (this.hasSubmittedBefore) {
        return {
          title: this.PageLeaveContent.SubmitTitle,
          text: this.PageLeaveContent.SubmitText,
          confirmBtn: this.PageLeaveContent.SubmitConfirmBtn,
        };
      }
      return {
        title: this.PageLeaveContent.SaveTitle,
        text: this.PageLeaveContent.SaveText,
        confirmBtn: this.PageLeaveContent.SaveConfirmBtn,
      };
    },
    saveCompanyInfoFromTabChange(toPage) {
      if (this.isApprovalMode) {
        if (!this.showProductRejectPanels) {
          if (toPage !== undefined && toPage !== null) {
            this.TabIndex = toPage;
            this.selectedTabName = this.TabList[toPage]?.ProgressPage || '';
          }
          return;
        }
        const goNext = () => {
          if (toPage !== undefined && toPage !== null) {
            this.TabIndex = toPage;
            this.selectedTabName = this.TabList[toPage]?.ProgressPage || '';
          }
        };
        // 与供应商 dirty 一致：有驳回改动才落库并提示
        if (this.hasApprovalRejectChanges('current')) {
          this.saveApprovalRejectContent({ silent: false, scope: 'current' }).then(goNext);
        } else {
          goNext();
        }
        return;
      }
      this.isSavingOrSubmiting = true;
      this.SaveChildPage().then(res => {
        if (!res.isSuccessful) {
          this.closeSubmitProgressModal();
          this.ShowResultMessagePopup(false, res.popupAlertMsg || this.$t("lbl_EMPBE_Save_Failed"), false);
          return;
        }
        this.refreshDraftBannerTimestamps();
        this.closeSubmitProgressModal();
        this.$store.state.dirty = false;
        if (toPage !== undefined && toPage !== null) {
          this.TabIndex = toPage;
          this.selectedTabName = this.TabList[toPage]?.ProgressPage || '';
        }
        this.loadData();
        // Figma：成功轻提示（3s / 300ms 淡出 / 不叠多个）
        this.$showEmpSuccessToast();
      }).catch(err => {
        this.closeSubmitProgressModal();
        this.ShowResultMessagePopup(false, err.popupAlertMsg || this.$t("lbl_emp2_PopupFailedBody"), false);
        if (err.error) {
          console.error(err.error);
        }
      }).finally(() => {
        this.isSavingOrSubmiting = false;
      });
    },
    submitCompanyInfoFromTabChange() {
      this.submitCompanyInfo();
    },
    handlePageLeaveAction(result, next) {
      if (result.isDenied) {
        next();
        return;
      }
      if (!result.isConfirmed) {
        return;
      }
      if (this.hasSubmittedBefore) {
        this.submitCompanyInfo();
        return;
      }
      this.isSavingOrSubmiting = true;
      this.SaveChildPage().then(res => {
        if (res.isSuccessful) {
          next();
        } else {
          this.ShowResultMessagePopup(false, res.popupAlertMsg || this.$t("lbl_EMPBE_Save_Failed"), false);
        }
      }).catch(err => {
        this.ShowResultMessagePopup(false, err.popupAlertMsg || this.$t("lbl_emp2_PopupFailedBody"), false);
        if (err.error) {
          console.error(err.error);
        }
      }).finally(() => {
        this.isSavingOrSubmiting = false;
      });
    },
  },
};
</script>
<style lang="scss">
@import "../NewproductInfoCenter/style/default";
@import "./style/default";
</style>
<style scoped>
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.container-fluid {
  position: relative;
}

.tbbody {
  display: flex;
  justify-content: center;
  position: relative;
}

.form {
  width: 100%;
  max-width: 1167px;
  box-sizing: border-box;
}

.form,
.formAdmin {
  --np-form-gutter-x: 16px;
}

.form .PublicTabs,
.formAdmin .PublicTabs {
  padding-left: var(--np-form-gutter-x, 16px);
  padding-right: var(--np-form-gutter-x, 16px);
}

.form > .product-reject-banner,
.formAdmin > .product-reject-banner,
.formAdmin > .company-overall-reject {
  margin-left: var(--np-form-gutter-x, 16px);
  margin-right: var(--np-form-gutter-x, 16px);
  width: calc(100% - 2 * var(--np-form-gutter-x, 16px));
  box-sizing: border-box;
}

.formAdmin > .product-reject-banner {
  margin-bottom: 16px;
}

.TabHeader {
  width: var(--np-form-width, 1167px);
  max-width: 1167px;
  left: var(--np-form-left, 0);
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  display: flex;
  position: fixed;
  top: 30px;
  z-index: 3;
  background: #F8F8F8;
  padding-left: var(--np-form-gutter-x, 16px);
  padding-right: var(--np-form-gutter-x, 16px);
  box-sizing: border-box;
}

.TabHeader_body {
  width: 100%;
  border-radius: 16px;
  align-items: flex-start;
  display: inline-flex;
  min-height: 34px;
  height: auto;
  margin: 12px 0;
  position: relative;
}

.topMenuRight {
  gap: 8px;
  min-height: 34px;
  justify-content: flex-end;
  align-items: flex-start;
  display: flex;
  position: absolute;
  right: 0;
}

.topActionGroup {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.topActionGroup > * {
  height: auto;
}

.headerActionBtn-wrap {
  display: inline-flex;
}

.headerActionBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  border: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.154px;
  height: 36px;
  padding: 0 8px;
  min-width: 0;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.headerActionBtn:not(:disabled):hover {
  background: rgba(0, 0, 0, 0.08);
}

.headerActionBtn:not(:disabled):active {
  background: rgba(0, 0, 0, 0.12);
}

.headerActionBtn__label {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 4px;
  line-height: 20px;
  white-space: nowrap;
}

.headerActionBtn__icon {
  width: 15px;
  height: 15px;
  margin: 0;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}

.headerActionBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.headerMoreAction {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 4px;
  border-radius: 0;
  background: transparent;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.154px;
  min-width: 0;
  box-sizing: border-box;
  white-space: nowrap;
}

.headerTitleBlock {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.headerBreadcrumbLine {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.statusLine {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.statusLabel {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.statusPill {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.statusPill.is-approved { background: #51bb25; color: #fff; }
.statusPill.is-rejected { background: #de3a4a; color: #fff; }
.statusPill.is-syncing { background: #3a7bd5; color: #fff; }
.statusPill.is-manual,
.statusPill.is-not-submitted { background: #ffd02c; color: rgba(0, 0, 0, 0.8); }

.product-launch-badge__dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #9e9e9e;
  flex-shrink: 0;
  margin-right: 4px;
}

.statusPill.is-launch-online {
  background: rgba(0, 255, 0, 0.25);
  color: #51BB25;
}
.is-launch-online .product-launch-badge__dot {
  background: #51bb25;
}
.statusPill.is-launch-offline {
  color: rgba(0, 0, 0, 0.60);
  background: rgba(0, 0, 0, 0.05);
}

.lblproductList {
  color: rgba(0, 0, 0, 0.40);
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

.productTitle {
  color: rgba(0, 0, 0, 0.80);
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
  max-width: 560px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iconRight {
  color: rgba(0, 0, 0, 0.40);
  font-size: 18px;
}

.product-draft-banner {
  margin: 0;
  padding: 12px 32px;
  border-radius: 0;
  background: #ffd02c;
  color: #5c4300;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  min-height: 44px;
  overflow: visible;
  white-space: normal;
}

.product-draft-banner__icon {
  flex-shrink: 0;
  width: 19px;
  height: 24px;
  display: block;
  margin-top: 0;
}

.product-draft-banner__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.product-draft-banner__title {
  font-size: 16px !important;
  font-weight: 700;
  line-height: 18px;
  color: #5c4300 !important;
}

.product-draft-banner__desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #5c4300 !important;
}

.form .product-draft-banner--above-body {
  width: calc(100vw - var(--np-main-offset-left, 0px));
  max-width: calc(100vw - var(--np-main-offset-left, 0px));
  margin-left: calc(
    var(--np-main-offset-left, 0px)
    - var(--np-header-offset-left, 0px)
    - var(--np-form-gutter-x, 16px)
  );
  margin-right: 0;
  box-sizing: border-box; 
}

.formAdmin .product-draft-banner--above-body {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  box-sizing: border-box;
  align-items: center;
}

.form .productInfo {
  padding-top: var(--np-content-top, 64px) !important;
}

.form .leftCard_proInfo {
  top: var(--np-left-top, 128px) !important;
}

.form .tab-left-Big {
  top: var(--np-left-top, 128px) !important;
}
</style>
<style>
.formAdmin .PublicTabs {
  padding-top: 0 !important;
}

#Newproductbox:has(.formAdmin) {
  background: #fff;
  min-height: 0;
}

#Newproductbox:has(.formAdmin) .container-fluid {
  padding-top: 0 !important;
}

.formAdmin {
  width: 100%;
  background: #fff;
  min-height: 0;
}

.formAdmin .bCardStyle,
.formAdmin .assitantCard,
.formAdmin .CenterCard {
  border-color: rgba(0, 0, 0, 0.12) !important;
}

/* 管理员编辑/审批共用：左侧选项卡宽度与审批模式一致（约 25%） */
.formAdmin .tab-left-tab {
  flex: 0 0 calc((100% - 24px) * 0.25) !important;
  max-width: calc((100% - 24px) * 0.25) !important;
  width: auto !important;
  padding-right: 0 !important;
}

.formAdmin .tab-center-tab {
  flex: 1 1 0 !important;
  max-width: none !important;
  width: auto !important;
  padding-right: 0px !important;
}

#companyBox .TabHeader_admin {
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  display: flex;
  background: #fff;
  background-clip: padding-box;
  border-bottom: 1px solid transparent;
  margin: 0;
  padding: 0 var(--np-form-gutter-x, 16px) 16px;
  position: sticky !important;
  top: 0;
  z-index: 10;
  pointer-events: auto;
  overflow: visible;
  box-sizing: border-box;
}

.TabHeader_admin .TabHeader_body {
  position: relative;
  z-index: 1;
  overflow: visible;
  margin: 0 !important;
  width: 100%;
  min-height: 34px;
  align-items: center;
}

.TabHeader_admin .topMenuRight {
  right: 8px;
  z-index: 51;
  overflow: visible;
}

.formAdmin .headerTitleBlock {
  min-height: 34px;
  justify-content: center;
  gap: 0;
}

/* 总驳回不吸顶：略高于 PublicTabs，但须低于吸顶 TabHeader_admin(10) */
.formAdmin > .company-overall-reject {
  margin: 0 var(--np-form-gutter-x, 16px) 12px;
  width: calc(100% - 2 * var(--np-form-gutter-x, 16px));
  position: relative;
  z-index: 2;
  overflow: visible;
  pointer-events: auto !important;
  box-sizing: border-box;
}
.formAdmin > .company-overall-reject:has(.dropdown.show) {
  z-index: 4;
}
.formAdmin > .company-overall-reject .frf__status,
.formAdmin > .company-overall-reject .frf__input,
.formAdmin > .company-overall-reject .frf__template-dd {
  pointer-events: auto !important;
}

.product-reject-banner {
  margin: 0;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid #dc3545;
  background: rgba(255, 230, 230, 0.4);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
}

.product-reject-banner__title {
  color: #dc3545;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
}

.product-reject-banner__desc-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.product-reject-banner__desc {
  margin: 0;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
}

.product-reject-banner__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 21px;
  margin: 0;
  border: 0;
  background: transparent;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}

.product-reject-banner__link-icon {
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.8);
}

.product-reject-banner__link:hover {
  text-decoration: underline;
}

/*
 * 审批只读：禁止改表单，但驳回框要能聚焦输入。
 * 勿在容器上用 pointer-events:none —— Chromium 下祖先 none 时，
 * 子级即便 auto，textarea 也经常点得着却无法输入。
 */
.product-submit-fieldset.is-approval-readonly input,
.product-submit-fieldset.is-approval-readonly textarea,
.product-submit-fieldset.is-approval-readonly select,
.product-submit-fieldset.is-approval-readonly button,
.product-submit-fieldset.is-approval-readonly a,
.product-submit-fieldset.is-approval-readonly label,
.product-submit-fieldset.is-approval-readonly [contenteditable],
.product-submit-fieldset.is-approval-readonly .vue-treeselect,
.product-submit-fieldset.is-approval-readonly .mx-datepicker,
.product-submit-fieldset.is-approval-readonly .custom-file,
.product-submit-fieldset.is-approval-readonly .gallery-item,
.product-submit-fieldset.is-approval-readonly .gallery-item-add {
  pointer-events: none !important;
}

.product-submit-fieldset.is-approval-readonly .company-field-approval-results,
.product-submit-fieldset.is-approval-readonly .company-field-approval-results *,
.product-submit-fieldset.is-approval-readonly .product-field-approval-results,
.product-submit-fieldset.is-approval-readonly .product-field-approval-results *,
.product-submit-fieldset.is-approval-readonly .product-approval-result-field,
.product-submit-fieldset.is-approval-readonly .product-approval-result-field *,
.product-submit-fieldset.is-approval-readonly .frf,
.product-submit-fieldset.is-approval-readonly .frf *,
.product-submit-fieldset.is-approval-readonly .frf input,
.product-submit-fieldset.is-approval-readonly .frf textarea,
.product-submit-fieldset.is-approval-readonly .frf button,
.product-submit-fieldset.is-approval-readonly .frf__input,
.product-submit-fieldset.is-approval-readonly .mrb,
.product-submit-fieldset.is-approval-readonly .mrb *,
.product-submit-fieldset.is-approval-readonly .mag,
.product-submit-fieldset.is-approval-readonly .mag *,
.product-submit-fieldset.is-approval-readonly .mag button,
.product-submit-fieldset.is-approval-readonly .mpp-overlay,
.product-submit-fieldset.is-approval-readonly .mpp-overlay * {
  pointer-events: auto !important;
}

/* placeholder 盖在输入框上，必须继续穿透，否则空原因时点不进去 */
.product-submit-fieldset.is-approval-readonly .frf__placeholder {
  pointer-events: none !important;
}

.form .productInfo {
  padding-top: var(--np-content-top, 64px) !important;
}

.form .leftCard_proInfo {
  top: var(--np-left-top, 128px) !important;
}

.form .tab-left-Big {
  top: var(--np-left-top, 128px) !important;
}

.TabHeader .product-reject-banner {
  width: 100%;
  margin: 0;
}
</style>
<style>
.parent {
  position: relative;
  padding-top: 30px;
}

.child {
  /* position: absolute;
  top: 0px;
  right: 0;
  padding: 20px; */
  color: rgba(43, 43, 43, 0.54);
  /*font-size: 16px !important;
   padding-right: 50px; */
}

.timeRight {
  display: inline-block;
  width: 155px;
  text-align: left;
  padding-left: 5px;
}
</style>
